/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useNavigate } from 'react-router-dom'
import { Field, FormikProvider, useFormik } from 'formik'
import { requestPassword } from '../core/_requests'
import {  MESSAGES } from '../../../utlis/messages'
import FieldInputText from '../../common/FieldInputText'
import SubmitButton from '../../common/SubmitButton'
import { useDispatch, useSelector } from 'react-redux'
import { ForgetPasswordAction } from '../../../redux/features/auth/authActions'
import Logo from "../../../../_metronic/assets/images/logo.png";

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email(MESSAGES.EMAIL_INVALID_FORMAT)
    .min(3, MESSAGES.MIN_3_CHARACTERS_REQUIRED)
    .max(50, MESSAGES.MAX_50_CHARACTERS_ALLOWED)
    .required(MESSAGES.EMAIL_REQUIRED),
})

export function ForgotPassword() {
  const dispatch: any = useDispatch();
  const forgetPasswordSlice = useSelector((state: any) => state.forgetPasswordSlice)

  const navigate = useNavigate()

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      dispatch(ForgetPasswordAction({ values, navigate }))
    },
  })

  return (
    <FormikProvider value={formik}>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          <div className='text-center logo-wrap'>
            {/* <img src={Logo} alt='logo'/> */}
          </div>
          <h1 className='text-dark fw-bolder mb-3'>{MESSAGES.FORGOT_YOUR_PASSWORD}</h1>
          <div className='text-gray-500 fw-semibold fs-6'>
            {MESSAGES.FORGET_PASSWORD_TITLE}
          </div>

        </div>
        <div className='fv-row mb-8'>
          <Field
            name="email"
            validate={forgotPasswordSchema}
            label="Email"
            type="email"
            required={true}
            component={FieldInputText}
            placeholder="Email"
          />
        </div>
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <SubmitButton title="Invia" type='submit' loading={forgetPasswordSlice?.loading} />
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-light'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {MESSAGES.CANCEL}
            </button>
          </Link>{' '}
        </div>
      </form>
    </FormikProvider>
  )
}
